<template>
  <div
    @mouseover="isTooltipActive = true"
    @mouseleave="isTooltipActive = false"
    class="c-contentsTooltip"
  >
    <balloon-tooltip
      :is-active="isTooltipActive"
      :hidden-title="true"
      :hidden-footer="true"
      @mouseover="isTooltipActive = true"
      @mouseleave="isTooltipActive = false"
      position="is-top-center"
      width="320px"
      class="c-contentsTooltip_balloon"
    >
      <coconala-icon
        class="c-contentsTooltip_trigger"
        slot="trigger"
        @mouseover="isTooltipActive = true"
        @mouseleave="isTooltipActive = false"
        name="question-circle-o"
        size="14px"
      />
      <div slot="body">
        <slot name="body" />
      </div>
    </balloon-tooltip>
  </div>
</template>
<script>
import BalloonTooltip from '~/components/molecules/BalloonTooltip'

// vuex
import { mapGetters } from 'vuex'

export default {
  components: {
    BalloonTooltip
  },
  name: 'ContentsTooltip',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isTooltipActive: false
    }
  }
}
</script>
<style lang="scss" scoped>
.c-contentsTooltip {
  &_balloon {
    text-align: left;
    display: inline;

    /deep/ .c-balloonDropdown {
      text-align: left;
      display: inline;
    }
  }

  &_trigger {
    color: $color-gray-300;
  }
}
</style>
